
import { IInvoiceService } from "../../domain/interfaces/IInvoiceService"
import { IEstablishmentAsCustomerData } from "../dtos/IEstablishmentAsCustomerData";

const EstablishmentAsCustomerUseCase = async (invoiceService: IInvoiceService, localId: string, document: string): Promise<IEstablishmentAsCustomerData> => {
    const response = await invoiceService.EstablishmentAsCustomer(localId, document);
    return response;
}

export default EstablishmentAsCustomerUseCase;